/*
 * Parallax scroll effect — matches tf.design production behavior exactly.
 *
 * data-parallax='{"factor": 0.1, "applyOffset": false}'
 *   factor: portion of scroll delta applied as translateY
 *   applyOffset: true  = effect centered around element's doc position
 *                false = effect relative to page top, adds negative margin-bottom
 *
 * Disabled on mobile (<=768px) unless data-parallax-phone="true".
 */
(function () {
  var PHONE_MAX = 768;
  var items = [];
  var ticking = false;

  function getDocOffset(el) {
    var rect = el.getBoundingClientRect();
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return Math.round(rect.top) + scrollTop;
  }

  function getTranslateY(el) {
    var style = window.getComputedStyle(el);
    if (!style.transform || style.transform === 'none') return 0;
    try {
      var matrix = new DOMMatrixReadOnly(style.transform);
      return matrix.m42;
    } catch (e) {
      return 0;
    }
  }

  function init() {
    var els = document.querySelectorAll('[data-parallax]');
    if (!els.length) return;

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var conf = JSON.parse(el.dataset.parallax);
      var enablePhone = el.dataset.parallaxPhone === 'true';

      if (!conf.applyOffset) {
        el.style.marginBottom = '-' + (50 * conf.factor) + 'vw';
      }

      items.push({
        el: el,
        conf: conf,
        enablePhone: enablePhone,
        offsetTop: 0,
        disabled: false
      });
    }

    recalc();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', recalc, { passive: true });
    window.addEventListener('load', recalc);
  }

  function recalc() {
    var w = window.innerWidth;
    var h = window.innerHeight;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      if (!item.enablePhone && w <= PHONE_MAX) {
        item.el.style.transform = '';
        item.disabled = true;
        continue;
      }

      item.disabled = false;

      if (item.conf.applyOffset) {
        var existingY = getTranslateY(item.el);
        item.offsetTop = getDocOffset(item.el) + h / 2;
        if (existingY) {
          item.offsetTop -= existingY;
        }
      } else {
        item.offsetTop = 0;
      }
    }

    update();
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function update() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.disabled) continue;
      var shift = (item.offsetTop - scrollY) * item.conf.factor;
      item.el.style.transform = 'translate3d(0px, ' + shift + 'px, 0px)';
    }
    ticking = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
